'use strict';

var LHinfo = '';
var LHnick = '';
var LHurl = '';

function LHready() {
  if (document.readyState === 'complete') {
    (function () {
      var lh = document.createElement('script');
      lh.type = 'text/javascript';
      lh.async = true;
      lh.crossOrigin = 'anonymous';
      lh.src =
        '//server.livehelp.it/widgetjs/76447/4971.js?x=' + 1 * new Date();
      var node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(lh, node);
    })();
  } else {
    setTimeout('LHready()', 150);
  }
}

LHready();
